import {darkenColor, generateColorPaletteForWeight} from '@Utils/color.util';
import {getBalancedEventPalette, getThemedEventPalette} from '@Libraries/event-colors.library';
import type {EventColorInputs, EventColorScheme, EventStyleColors} from '@Components/event-wizard/event-style/event-style.types';
import {StyleVariant} from '@Components/event-wizard/event-style/event-style.types';

/** Legacy Register-button label color (white), preserved for the Classic variant. */
export const CLASSIC_BUTTON_TEXT_COLOR = '#ffffff';

export const getNewStyleColors = (primaryColor: string): EventStyleColors => {
  const white = '#ffffff';

  const getLightestShadeNonWhite = (colors: string[]): string => {
    for (let i = colors.length - 1; i >= 0; i--) {
      if (colors[i].toLowerCase() !== white) {
        return colors[i];
      }
    }
    return '';
  };

  const lighterShadeWeight = 30;
  const lightShadeWeight = 35;
  const darkShadeWeight = 25;
  const darkerShadeWeight = 30;

  const backgroundLighterArr = generateColorPaletteForWeight(primaryColor, lighterShadeWeight);
  const backgroundLighter = primaryColor === white ? white : getLightestShadeNonWhite(backgroundLighterArr);

  const backgroundLightArr = generateColorPaletteForWeight(primaryColor, lightShadeWeight);
  const backgroundLight = primaryColor === white ? white : getLightestShadeNonWhite(backgroundLightArr);

  const darkTextColor = darkenColor(primaryColor, darkShadeWeight);
  const darkerTextColor = darkenColor(primaryColor, darkerShadeWeight);

  return {
    primary: primaryColor,
    lighter: backgroundLighter,
    light: backgroundLight,
    dark: darkTextColor,
    darker: darkerTextColor,
  };
};

/**
 * Decide the full event palette from the two inputs (plan §3.3). No custom
 * background → seed off the content color (Classic = today's `getNewStyleColors`,
 * Balanced = the improved palette), no page background emitted. Custom background
 * → seed off the background, with the content color used as the page text, and as the
 * accent's hue when the background is greyscale and has none of its own.
 */
export const getEventColorScheme = (inputs: EventColorInputs, variant: StyleVariant): EventColorScheme => {
  const {background, contentColor} = inputs;
  if (background === null) {
    if (variant === StyleVariant.BALANCED) {
      return getBalancedEventPalette(contentColor);
    }
    return {...getNewStyleColors(contentColor), background: null, buttonTextColor: CLASSIC_BUTTON_TEXT_COLOR};
  }

  return getThemedEventPalette(background, contentColor);
};
